import {
    RichTableColumns,
} from 'app/types/richtable.types'

const getColumns = (l: (key: string) => string) => {
    return [
        {
            id: 'noteSubject',
            headerProps: {
                children: l('NOTE_SUBJECT'),
            },
            mapCellProps: 'noteSubject',
        },
        {
            id: 'noteText',
            headerProps: {
                children: l('NOTE_TEXT'),
            },
            mapCellProps: 'noteText',
        },
        {
            id: 'createdBy',
            headerProps: {
                children: l('CREATED_BY'),
            },
            mapCellProps: 'createdBy',
        },
        {
            id: 'validDateTimestamp',
            headerProps: {
                children: l('VALID_DATE_TIMESTAMP'),
            },
            mapCellProps: 'validDateTimestamp',
            componentName: 'DateTimeCell',
        },
    ] as RichTableColumns[]
}

export default getColumns
